import React, { useState } from 'react';
import { Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import * as Classes from './styles.module.scss';

const RemoveCartItem = ({
  removeCartItem, id, onRemove, label
}) => {
  const [removing, setRemoving] = useState(false);

  const onClick = (e) => {
    e.preventDefault();
    setRemoving(true);
    if (onRemove) {
      onRemove();
    } else {
      removeCartItem(id);
    }
  };

  const content = removing ? (
    <Loader active inline />
  ) : (
    <button type="button" onClick={ onClick }>
      { label || 'Remove' }
    </button>
  );

  return (
    <div className={ Classes.remove }>
      { content }
    </div>
  );
};

RemoveCartItem.propTypes = {
  removeCartItem: PropTypes.func,
  id: PropTypes.number,
  onRemove: PropTypes.func,
  label: PropTypes.string
};

export default RemoveCartItem;
